import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import style from './CardSwiper.module.css';

const CardSwiper = ({ children, slidesPerView = 1.15, spaceBetween = 12 }) => {
    return (
        <div className={style.wrap}>
            <Swiper
                modules={[Pagination]}
                pagination={{ clickable: true }}
                slidesPerView={slidesPerView}
                spaceBetween={spaceBetween}
            >
                {React.Children.map(children, (child, i) => (
                    <SwiperSlide key={i}>{child}</SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default CardSwiper;